import React from "react";
import OrganizerTimePillSelect from "../components/OrganizerTimePillSelect";
import { DIAS_SEMANA } from "../reservas/primerUso/barPayload";
import { tramoSiguiente } from "./profesionalPayload";
import "./turnos-beauty.css";
import "../components/EventFormPickers.css";
import "../reservas/reservas-organizer.css";

const calcularHoras = (open, close) => {
  if (!open || !close) return 0;
  const [h1, m1] = open.split(":").map(Number);
  const [h2, m2] = close.split(":").map(Number);
  const diff = h2 * 60 + m2 - (h1 * 60 + m1);
  return diff > 0 ? Number((diff / 60).toFixed(1)) : 0;
};

/** Weekly schedule of a professional: per weekday a toggle and one or more ranges, matching SalonForm. */
const HorarioSemanal = ({ horario, onChange, onCopiarSalon }) => {
  const setDia = (weekday, patch) =>
    onChange({ ...horario, [weekday]: { ...horario[weekday], ...patch } });

  const setTramo = (weekday, i, patch) =>
    setDia(weekday, {
      tramos: horario[weekday].tramos.map((t, j) => (j === i ? { ...t, ...patch } : t)),
    });

  const totalHoras = DIAS_SEMANA.reduce((sum, { weekday }) => {
    const d = horario[weekday];
    if (!d?.enabled) return sum;
    const horasDia = (d.tramos || []).reduce((acc, t) => acc + calcularHoras(t.open, t.close), 0);
    return sum + horasDia;
  }, 0);

  return (
    <div className="zr-panel" style={{ padding: 18, border: "1px solid #e2e8f0", borderRadius: 10, background: "#fff" }}>
      <div className="bt-hs-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
        <div>
          <span className="zr-field__label" style={{ margin: 0, fontSize: 14, fontWeight: 700, color: "#1e293b" }}>
            Horarios de atención
          </span>
          <span className="zr-field__hint" style={{ display: "block", marginTop: 2 }}>
            Activa los días que trabaja y definí la franja horaria de cada uno.
          </span>
        </div>
        {onCopiarSalon && (
          <button type="button" className="zr-btn zr-btn--ghost" onClick={onCopiarSalon} style={{ fontSize: 12 }}>
            Copiar horario del salón
          </button>
        )}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {DIAS_SEMANA.map(({ weekday, largo }) => {
          const d = horario[weekday] || { enabled: false, tramos: [{ open: "09:00", close: "20:00" }] };
          return (
            <div
              key={weekday}
              className="zr-day-row bt-day-row"
              style={{
                height: "auto",
                minHeight: 48,
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                marginBottom: 0,
                paddingBottom: 12,
                borderBottom: "1px solid #f1f5f9",
                gap: 16,
              }}
            >
              <div className="bt-day-row__lead" style={{ display: "flex", alignItems: "center", gap: 12, paddingTop: 6, flexShrink: 0 }}>
                <span className="zr-day-row__name" style={{ width: 100 }}>
                  {largo}
                </span>
                <input
                  type="checkbox"
                  className="zr-switch"
                  aria-label={largo}
                  checked={d.enabled}
                  onChange={(e) => setDia(weekday, { enabled: e.target.checked })}
                />
              </div>

              <div className="bt-day-row__tramos" style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: "flex-end", flex: 1, minWidth: 0 }}>
                {d.tramos.map((t, i) => (
                  <div key={i} className="bt-tramo" style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
                    <OrganizerTimePillSelect
                      className="pu-time-fixed"
                      triggerClassName="zr-day-row__time"
                      ariaLabel={`Entrada del ${largo} (tramo ${i + 1})`}
                      value={t.open}
                      disabled={!d.enabled}
                      onChange={(val) => setTramo(weekday, i, { open: val })}
                      quarterHours
                    />
                    <span style={{ color: "#94a3b8", fontSize: 13, fontWeight: 600 }}>a</span>
                    <OrganizerTimePillSelect
                      className="pu-time-fixed"
                      triggerClassName="zr-day-row__time"
                      ariaLabel={`Salida del ${largo} (tramo ${i + 1})`}
                      value={t.close}
                      disabled={!d.enabled}
                      onChange={(val) => setTramo(weekday, i, { close: val })}
                      quarterHours
                    />
                    {d.enabled && d.tramos.length > 1 && (
                      <button
                        type="button"
                        className="zr-btn zr-btn--ghost"
                        aria-label={`Quitar tramo ${i + 1} del ${largo}`}
                        style={{ padding: "4px 8px", fontSize: 16, lineHeight: 1 }}
                        onClick={() => setDia(weekday, { tramos: d.tramos.filter((_, j) => j !== i) })}
                      >
                        ×
                      </button>
                    )}
                  </div>
                ))}

                {d.enabled && (
                  <div className="bt-tramo bt-tramo--add" style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                      type="button"
                      className="zr-btn zr-btn--ghost"
                      aria-label={`Agregar tramo al ${largo}`}
                      style={{ fontSize: 12, padding: "3px 10px", color: "var(--zr-ink)", border: "1px dashed #cbd5e1", borderRadius: 6 }}
                      onClick={() => setDia(weekday, { tramos: [...d.tramos, tramoSiguiente(d.tramos)] })}
                    >
                      + Agregar tramo
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Resumen semanal al pie, igual que en el formulario de edición del local */}
      <div style={{ marginTop: 18, paddingTop: 16, borderTop: "1px solid #e2e8f0" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 8 }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>Resumen semanal</span>
          <span className="zr-section-head__hint" style={{ margin: 0, fontSize: 13 }}>
            <b>{totalHoras}</b> hs en total
          </span>
        </div>
        <div className="zr-week">
          {DIAS_SEMANA.map(({ weekday, largo }) => {
            const d = horario[weekday];
            const on = d?.enabled;
            const hrs = on ? (d.tramos || []).reduce((sum, t) => sum + calcularHoras(t.open, t.close), 0) : 0;
            const corto = largo.slice(0, 3);
            return (
              <div key={weekday} className={"zr-week__day" + (on ? " zr-week__day--on" : "")}>
                <span>{corto}</span>
                {on && (
                  <span className="hrs">
                    {hrs} hs<br />al día
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HorarioSemanal;
